
import React from 'react';

interface FormPreviewHeaderProps {
  title: string;
  description?: string;
}

const FormPreviewHeader: React.FC<FormPreviewHeaderProps> = ({ title, description }) => {
  return (
    <div>
      <h2 className="text-2xl font-medium">{title}</h2>
      {description && (
        <p className="text-gray-600 mt-2">{description}</p>
      )}
    </div>
  );
};

export default FormPreviewHeader;
